import { usePlants, useSelectedPlant } from '../../../hooks';

import { Select } from '@pella/sash-framework';

/**
 * Plant selection atom component.
 * @param {Local.SelectionComponentsProps} props - Component props.
 */
export const SelectPlant = ({ id = 'plant-selection' }) => {
  const { data: plants } = usePlants(true);
  const { selectedPlant, setSelectedPlant } = useSelectedPlant();

  /**
   * Handles changes to the selected plant.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */
  const handlePlantChange = ({ target: { value } }) => {
    if (value) setSelectedPlant(value);
  };

  return (
    <Select id={id} data-testid={id} labelText='Select Plant' onChange={handlePlantChange} value={selectedPlant}>
      <option value=''>--- Select an Option ---</option>
      {plants?.map((plant) => (
        <option key={plant.id} value={plant.id}>
          {plant.description}
        </option>
      ))}
    </Select>
  );
};
